import { Component, Input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { StaticServeModule } from '@core/static-serve/static-serve.module';
import { DirectivesModule } from '@shared/directives/directives.module';
import { TranslateModule } from '@ngx-translate/core';
import { IAfterMinutesData } from '@pages/parents/pages/onboarding/pages/kyc/components/smart/kyc-pulling/models/interfaces/kyc-pulling.interfaces';
import { ComponentsModule } from '@shared/components/components.module';
import { AnimationOptions, LottieModule } from 'ngx-lottie';
import { CSpinner } from '@shared/components/spinner/models/constants/spinner.constants';

@Component({
  selector: 'mdk-kyc-validating-status',
  standalone: true,
  imports: [CommonModule, StaticServeModule, NgOptimizedImage, DirectivesModule, TranslateModule, ComponentsModule, LottieModule],
  templateUrl: './kyc-validating-status.component.html',
  styleUrls: ['./styles/kyc-validating-status.component.mobile.scss','./styles/kyc-validating-status.component.desktop.scss']
})
export class KycValidatingStatusComponent {

  //#region [---- [INPUTs OUTPUT] ----]
  @Input()public dataAfterMinutes:IAfterMinutesData = {
    iconSrc: '',
    description: ''
  }
  //#endregion

  //#region [---- [PROPERTIES] ----]
  public lottieConfig: AnimationOptions = {
    path: CSpinner.ELLIPSE_PATH,
    autoplay: true,
    loop: true,
  };
  //#endregion

  //#region [---- [LOGIC] ----]
  public renderEmoji(): string {
    if (this.dataAfterMinutes.iconSrc) {
      const codePoint = parseInt(this.dataAfterMinutes.iconSrc, 16);
      return String.fromCodePoint(codePoint);
    }
    return '';
  }
  //#endregion
}
